import './style/index.css';
import { Routes, Route } from 'react-router-dom';
import SearchUser from './components/Search';
import User from './components/User';

function App() {
    return (
      <>
        <Routes>
          <Route exact path='/' element={<SearchUser />} />
          <Route exact path='/user/:username' element={<User />}/>
        </Routes>  
      </>
    );
}

export default App;
